import { Injectable } from '@angular/core';
import { HttpService } from '../../http/http.service';
import { ApiEndpointService } from '../api-endpoint.service';
import { Observable } from 'rxjs/Observable';

export interface IColorPickerSetting {
  Id: string;
  SelectedColors: string;
}

@Injectable()
export class AccountColorsApi {
  constructor(private httpService: HttpService,
              private apiEndpoint: ApiEndpointService) {
  }

  getColors(): Observable<IColorPickerSetting> {
    return this.httpService.get(this.apiEndpoint.ColorPicker)
      .pipe((data) => {
        return data;
      });
  }

  setColors(data: IColorPickerSetting): Observable<boolean> {
    const headers: any = {
      'api-version': '1.0',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    return this.httpService.post(data, this.apiEndpoint.ColorPicker, headers);
  }
}
